var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7653 11.7651L12.9917 3.11904L12.1415 2.28125L5.53692 8.78982L2.51679 11.7651C2.36593 11.9146 2.28125 12.1168 2.28125 12.3276C2.28125 12.5383 2.36593 12.7405 2.51679 12.89L8.55067 18.8361L12.1415 22.3739L18.7452 15.8653L18.8481 15.7648L21.7653 12.8945C21.8409 12.8205 21.9009 12.7325 21.9419 12.6356C21.9828 12.5387 22.0039 12.4348 22.0039 12.3298C22.0039 12.2248 21.9828 12.1209 21.9419 12.024C21.9009 11.9271 21.8409 11.8391 21.7653 11.7651ZM12.1415 15.2984L9.12685 12.3276L12.1415 9.35672L15.1553 12.3276L12.1415 15.2984Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1417 9.35594C11.1936 8.42183 10.6591 7.15593 10.655 5.83475C10.6509 4.51358 11.1775 3.24449 12.1198 2.30469L5.52344 8.8025L9.11337 12.3402L12.1417 9.35594Z",
    fill: "url(#paint0_linear_2570_8650)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1626 12.3203L12.1406 15.2992C13.0923 16.2373 13.627 17.5095 13.627 18.8361C13.627 20.1626 13.0923 21.4348 12.1406 22.3729L18.7552 15.8581L15.1626 12.3203Z",
    fill: "url(#paint1_linear_2570_8650)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2570_8650",
    x1: 11.6019,
    y1: 6.35012,
    x2: 7.45377,
    y2: 10.5586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2570_8650",
    x1: 12.7159,
    y1: 18.2692,
    x2: 16.856,
    y2: 14.0689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.4524a9b31c6e6ffc336c11f65cb97d74.svg";
export { ForwardRef as ReactComponent };